document.querySelector("form").addEventListener("submit", function (event) {
  var marketingCheckbox = document.getElementById("marketing");
  var termsCheckbox = document.getElementById("terms");

  if (!marketingCheckbox.checked || !termsCheckbox.checked) {
    alert("Please agree to all terms and conditions.");
    event.preventDefault();
  }
});

 document.addEventListener("DOMContentLoaded", function() {
    var form = document.getElementById("ContactForm");
    var phoneInput = document.getElementById("ContactForm-phone");
    var phoneError = document.getElementById("phone-error");

    phoneInput.addEventListener("input", function() {
      this.value = this.value.replace(/\D/g, '');  // Remove any non-digit character
    });

    form.addEventListener("submit", function(event) {
      var phoneValue = phoneInput.value.trim();
      if (phoneValue.length < 10 || phoneValue.length > 15) {
        event.preventDefault();  // Stop form submission if invalid
        phoneError.style.display = 'block';  // Show error message
        phoneInput.focus();  // Focus on phone input
      } else {
        phoneError.style.display = 'none';  // Hide error message if valid
      }
    });
  });